<template>
  <w-input :title="title" :model="schema.$regex" @input="$emit('update')" />
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz do wpisania dowolnego tekstu
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true },
    // tytuł pola
    title: { type: String, required: true }
  }
};
</script>
